import { useCallback, useState } from 'react';
import { ButtonProps, Grid2 as Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card, EmptyState } from '@/components';
import { templateListSelector } from '@/features/admin/templates/slice';
import { menuSelector } from '@/features/menu/slice';
import { Menu, Template } from '@/types';

interface TemplateGalleryProps {
  type: 'select' | 'edit';
  onSelect?: (templateId: string) => void;
  onEdit?: (templateId: string) => void;
  onDelete?: (templateId: string) => void;
  templates?: Template[];
  onSettingsClick?: (template: Template) => void;
}

const TemplateGallery = ({
  onSelect,
  onEdit,
  onDelete,
  type = 'select',
  templates: propTemplates,
  onSettingsClick,
}: TemplateGalleryProps) => {
  const { menuId } = useParams();
  const [selectTemplate, setSelectTemplate] = useState<string>();
  const menu = useSelector(menuSelector(menuId ?? '')) as Menu;
  const reduxTemplates = useSelector(templateListSelector) as Template[];
  const templates = propTemplates ?? reduxTemplates;

  const handleSelectTemplate = (id: string) => {
    if (onSelect) onSelect(id);
    setSelectTemplate(id);
  };

  const handleEditTemplate = (id: string) => {
    if (onEdit) onEdit(id);
  };

  const handleDeleteTemplate = (id: string) => {
    if (onDelete) onDelete(id);
  };

  const getCardAction = useCallback(
    (templateId: Template['id']) => {
      if (type === 'select') {
        const isSelected = menu?.template === templateId || selectTemplate === templateId;
        const actions: ButtonProps[] = [
          {
            fullWidth: true,
            size: 'large',
            variant: isSelected ? 'contained' : 'outlined',
            color: isSelected ? 'success' : 'primary',
            children: isSelected ? 'Seleccionado' : 'Seleccionar',
            onClick: () => handleSelectTemplate(templateId),
          },
        ];
        return actions;
      }

      const actions: ButtonProps[] = [
        {
          fullWidth: true,
          size: 'large',
          variant: 'contained',
          color: 'primary',
          children: 'Editar',
          onClick: () => handleEditTemplate(templateId),
        },
        {
          fullWidth: true,
          size: 'large',
          variant: 'outlined',
          color: 'primary',
          children: 'Eliminar',
          onClick: () => handleDeleteTemplate(templateId),
        }
      ];
      return actions;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menu?.template, selectTemplate, type]
  );

  if (!templates?.length) {
    return <EmptyState title="No se encontraron plantillas disponibles" />;
  }

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      {templates.map((t, index) => (
        <Grid size={{ md: 6, lg: 4 }} key={`t-${index}`}>
          <Card
            title={t.title}
            image={t.image}
            description={'Lorem ipsum'}
            actions={getCardAction(t.id)}
            style={{ width: '100%', maxWidth: '100%' }}
            onSettingsClick={onSettingsClick ? () => onSettingsClick(t) : undefined}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default TemplateGallery;
